import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, Users, Shirt, TicketPercent } from 'lucide-react';
import ShopNavbar from '../components/ShopNavbar';
import AdminDashboard from '../components/admin/AdminDashboard';
import AdminOrders from '../components/admin/AdminOrders';
import OrderDrawer from '../components/admin/OrderDrawer';
import AdminCustomers from '../components/admin/AdminCustomers';
import AdminProducts from '../components/admin/AdminProducts';
import AdminDiscounts from '../components/admin/AdminDiscounts';
import '../styles/shop.css';

const TABS = [['dashboard', 'Dashboard', LayoutDashboard], ['orders', 'Orders', ShoppingBag], ['customers', 'Customers', Users], ['products', 'Products', Shirt], ['discounts', 'Discounts', TicketPercent]];
const currentUser = () => { try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } };

const Denied = () => (
  <div className="si-page"><ShopNavbar />
    <div className="max-w-xl mx-auto px-4 py-16"><div className="si-card p-8 text-center" data-testid="admin-denied">
      <p className="text-xl font-bold">Admin access only</p>
      <p className="mt-2 text-[var(--si-grey)]">Please log in with an admin account.</p>
      <Link to="/login?next=/admin" className="mt-5 si-btn si-btn-primary" data-testid="admin-login-link">Admin Login</Link>
    </div></div>
  </div>
);

const AdminShop = () => {
  const nav = useNavigate();
  const user = currentUser();
  const isAdmin = user?.role === 'admin' || user?.is_admin;
  const [tab, setTab] = useState('dashboard');
  const [orderFilter, setOrderFilter] = useState({ status: '', q: '' });
  const [openId, setOpenId] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => { if (!localStorage.getItem('token')) nav('/login?next=/admin'); }, [nav]);
  if (!isAdmin) return <Denied />;

  const goOrders = (status = '', q = '') => { setOrderFilter({ status, q }); setTab('orders'); };

  return (
    <div className="si-page">
      <ShopNavbar />
      <div className="max-w-7xl mx-auto px-3 md:px-6 py-5">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <h1 className="text-2xl md:text-3xl font-bold">Admin Panel</h1>
          <p className="text-sm text-[var(--si-grey)]">Signed in as <b>{user.email}</b></p>
        </div>
        <div className="flex gap-1 si-scroll-x border-b border-[var(--si-line)] mb-4" data-testid="admin-tabs">
          {TABS.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-bold border-b-[3px] whitespace-nowrap transition-colors ${tab === k ? 'border-[var(--si-orange)] text-[var(--si-navy)]' : 'border-transparent text-[var(--si-grey)] hover:text-[var(--si-navy)]'}`}>
              <Icon className="w-4 h-4" />{l}
            </button>
          ))}
        </div>
        <div className="si-card p-4 md:p-6">
          {tab === 'dashboard' && <AdminDashboard onOpenOrder={setOpenId} onGoOrders={(s) => goOrders(s)} />}
          {tab === 'orders' && <AdminOrders key={`${orderFilter.status}-${orderFilter.q}`} initial={orderFilter} onOpen={setOpenId} reloadKey={reloadKey} />}
          {tab === 'customers' && <AdminCustomers onSearchOrders={(email) => goOrders('', email)} />}
          {tab === 'products' && <AdminProducts />}
          {tab === 'discounts' && <AdminDiscounts />}
        </div>
      </div>
      {openId && <OrderDrawer id={openId} onClose={() => setOpenId(null)} onChanged={() => setReloadKey((k) => k + 1)} />}
    </div>
  );
};

export default AdminShop;
